import {css} from "@emotion/react";
import {TypographyProps} from "../types";


export const icon: { [name in NonNullable<TypographyProps['variant']>]: ReturnType<typeof css> } = {
    h1: css`
        width: 32px;
        min-width: 32px;
        max-width: 32px;
        height: 32px;
        display: flex;
        margin-right: 16px;
    `,
    h3: css(`
        width: 28px;
        min-width: 28px;
        max-width: 28px;
        height: 28px;
        display: flex;
        margin-right: 16px;
    `),
    h4: css(`
        height: 28px;
    `),    
    span: css(),
};

export const root = css`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
